import assessmentnew from "./assessmentnew";
export default [
  assessmentnew,
];
